import { DSSubscription } from 'shared-definitions/types'
import { ApiSubscriptionProps } from 'data-source/types.wp'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function subscriptionMapper(
  input: ApiSubscriptionProps,
  opts: PLinkMapperOpts
): Omit<DSSubscription, 'button'> {
  return {
    image: imageMapper(input.image, opts),
    title: input.title,
    text: input.description,
    listIds: input.list_ids.map(id => id.toString()),
  }
}
